import React, { useState } from "react";
import { Form, Input, Button, Checkbox } from "antd";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { userSignIn } from "../appRedux/actions/Auth";
import IntlMessages from "util/IntlMessages";
import InfoView from "components/InfoView";

const FormItem = Form.Item;

const SignIn = ({ form, userSignIn }) => {
  const [loading, setLoading] = useState(false);
  const { getFieldDecorator } = form;

  const currentYear = new Date().getFullYear();

  const handleSubmit = e => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        if (!loading) {
          setLoading(true);
          userSignIn(values.email, window.btoa(values.password));
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        }
      }
    });
  };

  return (
    <section className="login-container">
      <div className="gx-app-login-wrap">
            <div className="gx-app-graphic-content">
              <img alt="Sign in" src={require("assets/images/signin-graphic-new.png")} />
            </div>

            <div className="gx-app-login-content">
                  <div className="gx-app-logo">
                      <img alt="example" src={require("assets/images/clarity-logo.png")} />
                  </div>
                  <Form onSubmit={handleSubmit} className="gx-signin-form gx-form-row0">
                    <FormItem label="Email">
                      {getFieldDecorator('email', {
                        initialValue: "",
                        rules: [
                          { required: true, message: 'Please input your Email!' },
                          { type: 'email', message: 'The input is not a valid E-mail!' }
                        ],
                      })(
                        <Input />
                      )}
                    </FormItem>

                    <FormItem label={<><span>Password</span>
                        <Link to="/forgot-password">
                        <span>
                          <IntlMessages id="app.userAuth.forgotPassword" />
                        </span>
                      </Link></>}>
                      {getFieldDecorator('password', {
                        initialValue: "",
                        rules: [{ required: true, message: 'Please input your Password!' }],
                      })(
                        <Input.Password  />
                      )}
                    </FormItem>               

                    <FormItem style={{ marginTop: '30px', marginBottom: '10px' }}>
                      <Button type="primary" htmlType="submit" loading={loading} block>
                        <IntlMessages id="app.userAuth.signIn" />
                      </Button>
                    </FormItem>

                    <FormItem>
                      {getFieldDecorator('remember', {
                        valuePropName: 'checked',
                        initialValue: true,
                        rules: [{ required: true, message: 'Please accept the terms & conditions' }],
                      })(
                        <Checkbox onChange={() => form.validateFields(['remember'], { force: true })}><IntlMessages id="appModule.iAccept" /></Checkbox>
                      )}
                      <Link to="/terms" target="_blank">
                        <span className="gx-signup-form-forgot gx-pl-0">
                          <IntlMessages id="appModule.termAndCondition" />
                        </span>
                      </Link>
                    </FormItem>
                  </Form>

                  <p className="copy">©Clarity {currentYear}</p>
            </div>

            <InfoView />
      </div>
    </section>
  );
};

const WrappedSignIn = Form.create()(SignIn);

export default connect(null, { userSignIn })(WrappedSignIn);
